'use strict';

import template from './how_it_works.html';

const controller = [
  '$rootScope',
  '$scope',
  'breakpoint',
  'slideshow',
  'videos',

  function ($rootScope, $scope, breakpoint, slideshow) {

    this.playVideo = function () {
      this.slideshow.show([
        {
          vimeoId: 170788909,
          type: 'video',
        }
      ], 0, { isCounterVisible: false });
    };

    this.slideshow = slideshow;

    this.options = this.options || {};
    this.carouselOptions = {
      stack: this.options.stack
    };

    if (!this.options.breakpoints) {
      return;
    }

    var unbind;

    this.checkIfCarouselEnabled = function () {
      this.isCarouselEnabled = (this.options.breakpoints.indexOf(breakpoint()) > -1);
    };

    this.checkIfCarouselEnabled();

    unbind = $rootScope.$on('breakpointChanged', this.checkIfCarouselEnabled.bind(this));
    $scope.$on('$destroy', function () {
      unbind();
    });
  }
];

export default function f() {
  return {
    template: template,
    replace: true,
    scope: {
      options: '<'
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: controller
  };
}



// WEBPACK FOOTER //
// ./app/src/common/how_it_works/how_it_works.directive.js